import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import ClientPortal from "./pages/ClientPortal";
import Downloads from "./pages/Downloads";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/portal" element={<ClientPortal />} />
          <Route path="/downloads" element={<Downloads />} />
        </Routes>
        <Footer />
        <Chatbot />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
